import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { getLogs } from "@/http/getLogs"
import { useQuery } from "@tanstack/react-query"
import moment from "moment"
import { Badge } from "./ui/badge"
import { ScrollArea } from "./ui/scroll-area"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import { Info } from "lucide-react"


function getTextTooltip(tag, type) {
  const checkTag = (tag ?? "").split(";")
  if (type == "label") return checkTag[0]
  return checkTag[1]
}

function showTooltip(tag) {
  const checkTag = (tag ?? "").split(";")
  return checkTag[0] === "Visualizou o arquivo."
}

function getNomeUsuario(usuario) {
  const nome = usuario?.nome
  if (!nome) return "—"
  return nome.length > 15 ? nome.slice(0, 12) + "..." : nome
}

export function ModalLogs({ children, id }) {

  const { data } = useQuery({
    queryKey: ['getLogs', id],
    queryFn: () => getLogs(id),
    retry: true
  })

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Registros da solicitação</DialogTitle>

          <div className="px-3">
            <Table className='mt-4'>
              <TableHeader>
                <TableRow>
                  <TableHead>Data</TableHead>
                  <TableHead>TAG</TableHead>
                  <TableHead className="text-right">Usuário</TableHead>
                </TableRow>
              </TableHeader>
            </Table>
          </div>

          <ScrollArea className="h-72 px-3">
            <Table>
              <TableBody>
                {data?.map(item => (
                  <TableRow key={item._id}>
                    <TableCell className="font-medium">{moment(item.createdAt).format("DD/MM/YY HH:mm")}</TableCell>
                    {showTooltip(item.tag) ? <TableCell>
                      <Popover>
                        <PopoverTrigger className="cursor-pointer">
                          <div className="flex items-center gap-1">
                            <p>{getTextTooltip(item.tag, "label")}</p>
                            <Info className="size-4 text-zinc-400" />
                          </div>
                        </PopoverTrigger>
                        <PopoverContent className="w-80">
                          <p className="text-[12px] font-light whitespace-normal break-words">
                            {getTextTooltip(item.tag, "helpText")}
                          </p>
                        </PopoverContent>
                      </Popover>
                    </TableCell> : <TableCell>{item.tag}</TableCell>}
                    <TableCell className="text-right">
                      <Badge variant="outline">
                        {getNomeUsuario(item.usuarioID)}
                      </Badge>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </ScrollArea>

        </DialogHeader>
      </DialogContent>
    </Dialog>

  )
}